import React, { useState } from 'react';
import { X, Save, Edit3 } from 'lucide-react';

interface CustomContentModalProps {
  initialContent: string;
  onClose: () => void;
  onSave: (content: string) => void;
}

export const CustomContentModal: React.FC<CustomContentModalProps> = ({
  initialContent,
  onClose,
  onSave,
}) => {
  const [content, setContent] = useState(initialContent);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full flex flex-col">
        <div className="p-6 border-b flex justify-between items-center bg-gray-50 rounded-t-xl">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600">
              <Edit3 className="w-6 h-6" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                Własny opis (bez modyfikacji AI)
              </h2>
              <p className="text-sm text-gray-600">
                Wpisz dokładną treść posta. Ten tekst nie zostanie zmieniony przez sztuczną inteligencję.
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-200 rounded-full transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="w-full h-64 p-4 border rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Wpisz tutaj dokładną treść swojego posta..."
            autoFocus
          />
        </div>

        <div className="p-6 border-t bg-gray-50 rounded-b-xl flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Anuluj
          </button>
          <button
            onClick={() => onSave(content)}
            className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2 transition-all"
          >
            <Save className="w-4 h-4" />
            <span>Zapisz własny opis</span>
          </button>
        </div>
      </div>
    </div>
  );
};
